import React, { useEffect, useState, useRef } from 'react';
import './Authentication.css';
import {AppApiInstance, OauthAPIInstance} from '../../api/app-api';
import Util, {getRandomArbitrary, wait} from '../../utils/utils';
import { ApiCodes, DEFAULT_MESSAGE } from '../../api/error-code';
import { Row, Col } from 'reactstrap';
import QRCode from 'qrcode-react';
import {ApiPaths, EventTrackingList} from '../../api/const';
import * as qs from "query-string";
import moment from "moment";
import { useHistory } from 'react-router-dom';
import { GN_APP_ID } from '../../constant';
import {createSession, trackingEventCallAPI} from "../../api/trackingSDK";
import {redirectH5Binding} from "../CommonFunction";

const BINDING_CREATED = 'CREATED';
const BINDING_ACTIVE = 'ACTIVE';
const BINDING_EXPIRED = 'EXPIRED';
const RETURN_CODE_SUCCESS = 1;
const RETURN_CODE_EXPIRED = -7025;
const RETURN_CODE_ERROR = -7001;
const MAX_DELAY_QUERY = 3000; // SECONDS
const MIN_DELAY_QUERY = 1500;
export const BINDING_STATUS_MAP = {
  'CREATED' : "0",
  'ACTIVE' : "1",
  'EXPIRED' : "5",
}

const Authentication = () => {
  const [min, setMin] = useState("15")
  const [sec, setSec] = useState("00")
  const [valueQR, setValueQR] = useState("")
  const [remainTime, setRemainTime] = useState(900)
  const [iconUrl, setIconUrl] = useState("")
  const [merchantName, setMerchantName] = useState("")
  const [bindingInfo, setBindingInfo] = useState({})
  const timerId = useRef(false)
  const history = useHistory();
  const [sessionTracking, setSessionTracking] = useState('');
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    document.title = 'Authorization Page';
  }, []);

  useEffect(() => {
    let min = moment().startOf('day').seconds(remainTime).format('mm');
    let sec = moment().startOf('day').seconds(remainTime).format('ss');
    setMin(min)
    setSec(sec)

    if (remainTime <= 0) {
      clearInterval(timerId.current)
      history.push('/result', {
        step: -1,
        return_code: -7025,
        binding_info: bindingInfo
      })

    }
  }, [remainTime]);

  useEffect( () => {
    handleBindingV2();
    queryBinding(bindingInfo.id);
    if(document.readyState === "complete" ) {
      sendEventTracking(sessionTracking, 'renderUIComplete')
    }
    tickElapsedTime();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bindingInfo]);

  const handleCreateSession = () => {
    let session = ''
    createSession(res => {
      if (res) {
        setSessionTracking(res)
        session = res;
      }
    })

    return session;
  }
  const handleEventTrackingClientRequest = () => {
    let session = handleCreateSession();
    sendEventTracking(session, 'clientRequest')
  }

  const sendEventTracking = (session, eventName) => {
    const eventId = EventTrackingList.normalLandingPage.eventId[eventName];
    console.log(bindingInfo);
    const metaData = {
      agent: navigator.userAgent,
      requestID: bindingInfo?.id,
      appID: bindingInfo?.merchant?.app_id
    }
    trackingEventCallAPI(eventId, session, metaData)
  }

  const queryBinding = async(bindingID) => {
    const binding = await getBinding(bindingID);
    if(!binding) return;
    if(remainTime <= 0) return;
    if (isBindingFinished(binding)) {
      let returnCode = RETURN_CODE_ERROR;
      let step = -1;
      if(binding.status === BINDING_ACTIVE) {
        returnCode = RETURN_CODE_SUCCESS
        step = 1;
      }
      if (binding.status === BINDING_EXPIRED) {
        returnCode = RETURN_CODE_EXPIRED
      }

      history.push('/result', {
        step: step,
        status: binding.status,
        return_code: returnCode,
        return_message: '',
        binding_info: bindingInfo,
        isV2: true,
      });
      return;
    }

    let expireTime = new Date().getTime() + 15*60000
    let curTime = new Date().getTime();
    if(expireTime - curTime === 0 || !binding) return;
    const randomDeplay = getRandomArbitrary(MIN_DELAY_QUERY, MAX_DELAY_QUERY);
    return wait(randomDeplay, expireTime).then(async() => {return await queryBinding(bindingID)});
  }

  const handleBindingV1 = () => {
    if (!bindingInfo.binding_token) return;
    const mcInfo = Util.getMerchantInfo(bindingInfo);
    setMerchantName(mcInfo.merchant_name);
    setIconUrl(mcInfo.app_icon_url);
    if (bindingInfo.link) {
      setValueQR(bindingInfo.link);
    } else {
      setValueQR("zalopay://launch/app/731?view=confirm&b=" + bindingInfo.binding_token + "&appid=" + bindingInfo.app_id + "&s=web");
    }
  }

  const tickElapsedTime = () => {
    timerId.current = setInterval(() => {
      setRemainTime(remainTime => remainTime - 1);
    }, 1000);
    return () => {
      clearInterval(timerId.current)
    }
  }


  useEffect(() => {
    let params = qs.parse(window.location.href.split('?')[1]);
    if (Object.entries(params).length !== 0 && params.constructor !== Object) {
      let binding_token = params.binding_token;
      let param_key = params.key;
      const apiPath = ApiPaths.BINDING_INFO + binding_token;
      Util.showLoading();

      getBinding(binding_token).then(bindingV2 => {
        if (!bindingV2) {
          history.replace('/result', {
            step: -1,
            status: "EXPIRED",
            return_code: RETURN_CODE_EXPIRED,
            binding_info: bindingInfo
          });
          return;
        }
        console.log("bindingV2= ", bindingV2)
        Util.hideLoading();
        let returnCode = RETURN_CODE_ERROR;
        let step = -1;
        if(bindingV2?.status === BINDING_CREATED){
          setBindingInfo(bindingV2);
          return;
        }
        if(bindingV2?.status === BINDING_ACTIVE){
          setBindingInfo(bindingV2);
          returnCode = RETURN_CODE_SUCCESS
          step = 1;
          history.push('/result', {
            step: step,
            status: bindingV2.status,
            return_code: returnCode,
            return_message: '',
            binding_info: bindingInfo,
            isV2: true,
          });
        }

      }).finally(() => {
        Util.hideLoading();
      });
    }
  }, [])

  const getBinding = async (bindingID) => {
    try{
      const resp = await OauthAPIInstance.getBinding(bindingID);
      if (resp.status === 200) {
        return await resp.json();
      }
      return null;
    } catch (e) {
      console.log(e);
      return null;
    }
  }

  const handleBindingV2 = async () => {
    if (!bindingInfo.id) return;
    setMerchantName(Util.getCustomMerchantName(bindingInfo));
    setIconUrl(bindingInfo.merchant.logo)
    setValueQR(bindingInfo.links?.confirm + "?s=web")
  }

  const isBindingFinished = (binding) => {
    return binding?.status === BINDING_ACTIVE || binding?.status === BINDING_EXPIRED;
  }

  const goBack = () => {
    window.history.go(-1);
  }

  if (!initialized) {
    setInitialized(true);
    handleEventTrackingClientRequest();
  }

  return (
    <div>
      <Row>
        <Col md={12} id={"header"}>
          <div className="container">
            <div className="row">
              <div className="col-12">
                <p>Xác nhận hết hạn sau: <span>{min}:{sec}</span></p>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col md={12} id={"main-body"}>
          <div id="main-body">
            <div className="top-body">
              <div className="container">
                <div className="row">
                  <div className="left-side col-md-6">
                    <div className="previous-page">
                      <a href="#" onClick={goBack}><img
                        src="/img/icon-arrow-blue-left.svg"
                        alt="arrow" /> Quay lại trang trước</a>
                    </div>
                    {merchantName &&
                    <h1>Liên kết<br />Zalopay & {merchantName}</h1>
                    }
                    <p className="sub-title">Dùng ứng dụng Zalopay quét mã
                      để tiếp tục thanh toán dịch vụ {merchantName}</p>
                    <div className="logos">
                      <a href="#" className="logozp"><img
                        src="/img/logo-zp.svg"
                        alt="logo zalopay" /></a>
                      {iconUrl &&
                      <a href="#" className="logola"><img
                        src={iconUrl} alt="logo merchant" /></a>
                      }
                    </div>
                  </div>
                  <div className="right-side col-md-6">
                    <div className="qr-code-container">
                      <span className="qr-corner-left"><img
                        src="/img/qr-wrap.svg" alt="qr wrap" /></span>
                      <span className="qr-corner-right"><img
                        src="/img/qr-wrap.svg" alt="qr wrap" /></span>
                      <span className="qr-corner-bottom-left"><img
                        src="/img/qr-wrap.svg" alt="qr wrap" /></span>
                      <span className="qr-corner-bottom-right"><img
                        src="/img/qr-wrap.svg" alt="qr wrap" /></span>
                      <QRCode value={valueQR} className={"qrcode"} size={330} />
                    </div>
                    <div className="scan-waiting">
                      <img src="/img/waiting.svg" alt="waiting" /> Đang
                      chờ bạn quét mã
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="bottom-body">
              <div className="container">
                <div className="guide-steps row">
                  <div className="step1 col-md-4">
                    <div className="imgstep1"><img src="/img/step1.svg"
                                                   alt="step" /></div>
                    <p className="guide-text">Mở và đăng nhập vào<br />ứng
                      dụng Zalopay hoặc Zalo</p>
                  </div>
                  <div className="step2 col-md-4">
                    <div className="imgstep2"><img src="/img/step2.svg"
                                                   alt="step" /></div>
                    <p className="guide-text">Chọn tính năng quét mã <img
                      src="/img/icon-qr-scan.svg" alt="qr code" /><br />ở
                      góc trái màn hình</p>
                  </div>
                  <div className="step3 col-md-4">
                    <div className="imgstep3"><img src="/img/step3.svg"
                                                   alt="step" /></div>
                    <p className="guide-text">Đưa camera và quét mã<br />QR
                      ở trên</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col md={12} id={"zpfooter"}>
          <div className="container">
            <div className="row">
              <div className="appstores col-md-6">
                <a href="https://itunes.apple.com/vn/app/zalopay-thanh-to%C3%A1n-trong-2s/id1112407590?l=vi&mt=8" className="applestore">
                  <img src="/img/logo-apple.svg" alt="apple" />
                  <div className="store-text">
                    <p className="small-text">Tải ứng dụng từ</p>
                    <p className="store-name">App Store</p>
                  </div>
                </a>

                <a href="https://play.google.com/store/apps/details?id=vn.com.vng.zalopay&hl=en" className="playstore">
                  <img src="/img/logo_play.svg" alt="apple" />
                  <div className="store-text">
                    <p className="small-text">Tải ứng dụng từ</p>
                    <p className="store-name">Google Play</p>
                  </div>
                </a>

              </div>

              <div className="support-secure col-md-6">

                <h2>Hỗ trợ khách hàng</h2>
                <div className="support-list">
                  <a href="tel:1900545436" className="phone">
                    <div className="phone-icon"><img
                      src="/img/icon-phone.svg" alt="phone" /></div>
                    <div className="phone-number">
                      <p className="number">1900 54 54 36</p>
                      <p className="desc">(cước phí 1,000đ/phút)</p>
                    </div>
                  </a>
                  <a href="mailto:hotro@zalopay.vn" className="mail">
                    <div className="mail-icon"><img
                      src="/img/icon-mail.svg" alt="mail" /></div>
                    <div className="mail-text">
                      <p className="number">hotro@zalopay.vn</p>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Authentication;
